module.exports = __webpack_public_path__ + "img/location-singapore-5-hover.2edfc3d9.jpg";